import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAlert } from 'react-alert';
import Button from "../../components/common_components/Button";
import TextButton from "../../components/common_components/TextButton";
// import EthereumIcon from "../../../../../../assets/images/user_app/ethereum_icon.png";
import EthereumIcon from "../../../../../../assets/images/user_app/ethereum_logo_blue_2.png";
import PolygonIcon from "../../../../../../assets/images/user_app/polygon_icon.png";

import CompletedIcon from "../../../../../../assets/images/user_app/payout_success.svg";
import RejectedIcon from "../../../../../../assets/images/user_app/payout_rejected.svg";
import ClipLoader from "react-spinners/ClipLoader";

// API Calls
import CashOutAPI from "../../api/api_calls/CashOutAPI";


function PayoutsTable(props) {
    const alert = useAlert()
    const navigate = useNavigate();
    const isMobile = window.innerWidth < 800;
    console.log(props.payouts)

    // If there is a payout in "requested" status, show a notice
    const showPayoutPendingNotice = props.payouts && props.payouts.length > 0 && props.payouts.some(payout => payout.status === "requested")


    return (
        <div className="payouts-table-container">
            <div className="payouts-table-header">
                <h2 className="payouts-table-header-text">My balance: ${props.balance}</h2>
                <Button size="small" color="black-rainbow" fullWidth={isMobile} onClick={() => {
                    props.setShowRequestPayout(true)
                }}>
                    Request payout
                </Button>
            </div>

            {showPayoutPendingNotice && <div className="payout-pending-notice body-small">Payout requests may take up to 7 days to process.</div>}

            <div className="payouts-table-row-container">
                {props.payouts && props.payouts.length > 0 && props.payouts.map((payout) => (
                    <PayoutCard payout={payout} key={payout.id} updatePayouts={props.updatePayouts} />
                ))}
            </div>
        </div>
    )
}

function PayoutCard({ payout, updatePayouts }) {
    function shortAddress(address) {
        if (address && address.length > 0) {
            const first = address.substring(0, 6)
            const last = address.substring(address.length - 4, address.length)
            return first + "..." + last
        }
    }

    // Format amount to 2 decimal places
    const formattedAmount = Number(payout.usd_amount).toFixed(2)


    // Date in Sepot 24, 2025 format
    const date = new Date(payout.created_at)
    const formattedDate = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })

    const PayoutIcon = payout.blockchain == "Ethereum" ? EthereumIcon : PolygonIcon
    return (
        <div className="payout-card">
            <div className="payout-card-left-container">
                <div className="payout-card-date body-tiny"> {formattedDate}</div>
                <div className="payout-card-amount body-large"> ${formattedAmount}</div>
                <div className="payout-card-icon-and-address-container">
                    <img src={PayoutIcon} alt={payout.blockchain + " Icon"} height="22px" width="22px" />
                    <div className="payout-card-address body-small">{shortAddress(payout.eth_address)}</div>
                </div>
            </div>
            <PayoutStatus payout={payout} updatePayouts={updatePayouts} />
        </div>
    )
}

function PayoutStatus({ payout, updatePayouts }) {
    const alert = useAlert()

    async function CancelPayout(payout) {
        console.log("CancelPayout", payout)
        const response = await CashOutAPI.cancel(payout.id)

        if (response.success) {
            alert.success("Payout cancelled")
            updatePayouts()
        } else {
            alert.error("Failed to cancel payout")
        }
    }

    // Take the status and capitalize the first letter
    const status = payout.status ? payout.status.charAt(0).toUpperCase() + payout.status.slice(1) : "Unknown"
    var PayoutStatusIcon = null
    if (payout.status == "completed") {
        PayoutStatusIcon = <img src={CompletedIcon} alt="Completed Icon" height="22px" width="22px" />
    } else if (payout.status == "rejected") {
        PayoutStatusIcon = <img src={RejectedIcon} alt="Rejected Icon" height="22px" width="22px" />
    } else if (payout.status == "canceled") {
        PayoutStatusIcon = <img src={RejectedIcon} alt="Canceled Icon" height="22px" width="22px" />
    } else if (payout.status == "processing") {
        PayoutStatusIcon = <ClipLoader color="white" aria-label="Loading Spinner" size={22} />
    }


    return (
        <div className="payout-card-right-container">
            <div className="payout-card-status-and-link-container">
                <div className="payout-card-status body-small">{status}</div>
                {payout.transaction_link && payout.status == "completed" && <a href={payout.transaction_link} target="_blank" rel="noopener noreferrer" className="payout-card-transaction-link body-tiny">Transaction details</a>}
                {payout.status == "requested" && <LinkButton text="Cancel" onClick={() => { CancelPayout(payout) }} />}
            </div>
            {PayoutStatusIcon}
        </div>
    )
}

function LinkButton({ text, onClick }) {
    return (
        <button
            type="button"
            className="link-text-button body-tiny"
            onClick={onClick}
        >
            {text}
        </button>
    );
}

export default PayoutsTable;